<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Create Folder</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <form name="createDirectoryForm" [formGroup]="createDirectoryForm" (ngSubmit)="onSubmit(createDirectoryForm)" autocomplete="off" spellcheck="false">
    <mat-form-field  style="width: 100%;">
      <mat-label>Directory Name</mat-label>
      <input
        placeholder="Directory Name"
        formControlName="directoryName"
        matInput
        style="overflow: none!important;"
      />
      <mat-error
        *ngIf="createDirectoryForm.get('directoryName').touched &&
        createDirectoryForm.get('directoryName').errors?.required"
      >Required</mat-error>
      <mat-error
        *ngIf="createDirectoryForm.get('directoryName').touched &&
        createDirectoryForm.get('directoryName').errors?.pattern"
      >Name Invalid
        <span
          title="Only Alphabets, Number, '@', '_', '-', '.' and spaces allowed."
          class="bi bi-info"
        ></span>
      </mat-error>
      <mat-hint class="space-warning" *ngIf="showSpaceWarning">
        <span class="warning-icon bi bi-exclamation-triangle"></span>
        Spaces will be replaced with underscores.
      </mat-hint>
    </mat-form-field>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" mat-dialog-close>Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit(createDirectoryForm)">
    Create
  </button>
</div>
